import React from "react";
import { INDUSTRIES } from "../data/site";
import { Reveal, SectionHeading } from "./Reveal";

export const Industries = () => (
  <section id="industries" className="mx-auto max-w-7xl px-5 md:px-8 py-24 md:py-32">
    <Reveal>
      <SectionHeading overline="Industries We Work With" title="Trusted Across Heavy Industry" />
    </Reveal>

    <div className="mt-10 relative overflow-hidden border-y border-line py-6">
      <div className="flex whitespace-nowrap animate-marquee">
        {[...INDUSTRIES, ...INDUSTRIES].map((n, i) => (
          <span key={i} className="mx-6 font-head font-black uppercase text-3xl md:text-4xl text-white/10">
            {n} <span className="text-orange/40">/</span>
          </span>
        ))}
      </div>
    </div>

    <div className="mt-10 grid grid-cols-2 md:grid-cols-4 gap-px bg-line border border-line">
      {INDUSTRIES.map((n, i) => (
        <Reveal key={n} delay={i * 0.04}>
          <div
            data-testid={`industry-${i}`}
            className="group bg-ink-900 hover:bg-orange p-7 h-full transition-colors flex items-center"
          >
            <span className="font-head font-extrabold uppercase tracking-tight text-white/80 group-hover:text-white transition-colors">
              {n}
            </span>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
